import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading-spinner-button',
  imports: [MatProgressSpinnerModule],
  templateUrl: './loading-spinner-button.component.html',
  styleUrl: './loading-spinner-button.component.scss',
})
export class LoadingSpinnerButtonComponent {}
